function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

export function isSubdomainContext(): boolean {
  const value = getCookie('foxia_ws_context')
  return value === 'subdomain' || value === 'custom'
}

export function isCustomDomainContext(): boolean {
  return getCookie('foxia_ws_context') === 'custom'
}
